import React from "react";
import { Star } from "lucide-react";

// Sterren met gedeeltelijke vulling (4.8 = 4 volle + 80% van de vijfde).
const StarRating = ({ rating, size = "w-5 h-5", emptyClass = "text-amber-400/40", className = "" }) => (
  <div className={`flex ${className}`} role="img" aria-label={`${rating} van 5 sterren`}>
    {[...Array(5)].map((_, i) => {
      const fill = Math.min(1, Math.max(0, rating - i));
      return (
        <span key={i} className={`relative inline-block ${size}`}>
          <Star className={`absolute inset-0 w-full h-full ${emptyClass}`} aria-hidden="true" />
          <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
            <Star className={`${size} text-amber-400 fill-amber-400`} aria-hidden="true" />
          </span>
        </span>
      );
    })}
  </div>
);

export default StarRating;
